import { createFileRoute } from "@tanstack/react-router";

import { ReviewList } from "../review/ReviewList";
import { reviewQueueQueryOptions } from "../review/queries";

export const Route = createFileRoute("/_auth/review/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(reviewQueueQueryOptions({ status: "open" })),
  component: ReviewList,
});
